<template lang="pug">
  .page.page-analysis
    Result
    Recruitment
</template>

<script>
import Result from '../components/Result.vue';
import Recruitment from '../components/Recruitment.vue';

export default {
  name: 'AnalysisPage',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  components: {
    Result,
    Recruitment
  }
}
</script>

<style lang="scss">

</style>
